/**
 * VideoCallStateVariant — which non-video state view of the video-call page to
 * render. Each value maps to one Flutter `VideoCallScreenState` state widget
 * (video_call_screen.dart): calling → _callingAudienceUserWidget,
 * ended → _streamingEndedWidget, audienceNoJoin → _audienceUserDidNotJoinWidget,
 * renewingToken → _renewingTokenWidget.
 *
 * String-valued so the members round-trip the prior presentation string-literal
 * union unchanged — the `variant` prop on `VideoCallStateView` and the page call
 * sites read identically.
 */
export enum VideoCallStateVariant {
  calling = 'calling',
  ended = 'ended',
  audienceNoJoin = 'audienceNoJoin',
  renewingToken = 'renewingToken',
}
